<template>
  <div class="app-container">
    <el-table v-loading="loading" :data="businessqualificationList" @selection-change="handleSelectionChange" style="height: 250px;"   max-height="650">
      <!-- <el-table-column type="selection" width="40" align="center" /> -->
 
      <el-table-column label="风险项" align="center" prop="qualificationNo" />
  
      <el-table-column label="评估意见" align="center" prop="effectBegin" width="180">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.effectBegin, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
  
    </el-table>

<el-row :gutter="20" class="elrow">
  <el-col :span="8">
    <span>投标文件</span>
  <el-tree
            :data="tree"
            highlight-current
            node-key="id"
            :props="{
                children: 'children',
                label: 'name'
            }"
            @node-expand="openTreeNode"
            @node-collapse="closeTreeNode"
            ref="tree"
            @node-contextmenu="openTreeMenu"
            default-expand-all	
        >
        <template #default="{ node, data }">
      <span class="custom-node">
        <!-- 一级节点图标 -->
        <i v-if="node.level === 1" class="el-icon-folder-opened" v-html="'&nbsp;&nbsp;'"> </i>
        <!-- 二级节点图标 -->
        <i v-else-if="node.level === 2" class="el-icon-document" v-html="'&nbsp;&nbsp;'"></i>
        <!-- 三级节点图标 -->
        <i v-else-if="node.level === 3" class="el-icon-set-up" v-html="'&nbsp;&nbsp;'"></i>
        <!-- 其他节点图标 -->
        <i v-else class="el-icon-collection" v-html="'&nbsp;&nbsp;'"></i>
        <span>{{ node.label }}</span>
      </span>
    </template>
        </el-tree>
   
  </el-col>
  <el-col :span="16">
  
<div>

<div id="text-dom-il4xjiksUv3QTZS8Gt2xiH" class="text">
  <p class="listRTL listLTR" style="margin-bottom: 3.9px;">
    <span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">针对AI应用系统的服务器配置、部署和数据备份需求进行系统性规划，确保系统稳定运行和数据安全，具体包括：</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">1.服务器选型与配置方案：</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(189,49,36,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 700;line-height: 17px;">(1)硬件配置规划：CPU性能配置、内存容量规划、存储空间配置、网络带宽需求、服务器扩展能力；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(189,49,36,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 700;line-height: 17px;">(2)操作系统选型：系统版本选择、安全补丁策略、系统优化配置、系统监控方案；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(189,49,36,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 700;line-height: 17px;">(3)数据库配置：数据库类型选择、数据库参数优化、数据库性能调优、连接池配置；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(189,49,36,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 700;line-height: 17px;">(4)中间件配置：应用服务器选型、缓存服务配置、消息队列配置、负载均衡设置；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">2.系统部署方案：</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(1)部署架构设计：应用服务器集群方案、数据库集群方案、负载均衡架构、容灾备份架构；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(2)网络环境配置：网络拓扑设计、安全域划分、防火墙策略、访问控制策略；</span></p><p class="listRTL listLTR" style="margin-bottom: 3.9px;"><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(3)应用系统部署：智能报告模块部署、知识库模块部署、智能问数模块部署、系统集成配置；</span></p><p><span style="color: rgba(134,144,156,1);font-size: 12px;font-family: AlibabaPuHui;font-weight: 400;line-height: 17px;">(4)系统监控部署：性能监控配置、告警阈值设置、日志收集方案、监控可视化配置；</span></p></div>

</div>

</el-col>


</el-row>
  </div>
</template>

<script>
import { listRiskassessment, getRiskassessment, delRiskassessment, addRiskassessment, updateRiskassessment } from "@/api/intelligentinspection/riskassessment";

export default {
  name: "Riskassessment",
    props: {
    tree: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      // 遮罩层
      loading: false,
     
    };
  },
  created() {
    // this.getList();
  },
  methods: {
    /** 查询标书风险评估列表 */
    getList() {
      this.loading = true;
      listRiskassessment(this.queryParams).then(response => {
        this.riskassessmentList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        pid: null,
        tenantId: null,
        bidCode: null,
        assessmentType: null,
        assessmentItem: null,
        assessmentAdvise: null,
        contentPosition: null,
        version: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加标书风险评估";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getRiskassessment(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改标书风险评估";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updateRiskassessment(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addRiskassessment(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除标书风险评估编号为"' + pids + '"的数据项？').then(function() {
        return delRiskassessment(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('intelligentinspection/riskassessment/export', {
        ...this.queryParams
      }, `riskassessment_${new Date().getTime()}.xlsx`)
    },


  }
};
</script>
